<template>
  <div>
    <!-- 发布协议对话框 -->
    <el-dialog title="发布协议" :visible.sync="dialogVisible" width="40%" modal-append-to-body append-to-body
      close-on-click-modal @closed="handleClose">
      <h4 style="text-align: center;">是否发布此条协议，发布后不可撤回，请跟产品同学对齐</h4>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitForm">发 布</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { publishProtocol } from '@/api/protocolCompliance/protocolManage'
import Message from '@/components/Message'
export default {
  name: 'WebSaaSPublish',
  inject: ['loadList'],
  data() {
    return {
      dialogVisible: false,
      /** 协议id */
      id: '',
    };
  },
  methods: {
    /** 确认发布 */
    async submitForm() {
      const { data } = await publishProtocol(this.id)
      console.log('发布协议接口的响应', data);
      if (data.code === 200) {
        Message.success('发布成功');
        this.hide()
        this.loadList()
      }
    },
    //^ ^--------------对话框自身相关-------------^ ^
    show(id) {
      this.id = id;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.id = ''
    },
  },
};
</script>

<style lang="scss" scoped></style>